import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const EventHero = ({ title, date, time, location, difficulty, isNew, heroImage, heroImageAlt }) => {
  return (
    <div className="w-full">
      <div className="relative w-full min-h-[280px] h-auto md:h-80 lg:h-96 overflow-hidden">
        {heroImage ? (
          <Image
            src={heroImage}
            alt={heroImageAlt || title}
            className="w-full h-full object-cover absolute inset-0"
          />
        ) : (
          <div className="w-full h-full absolute inset-0 bg-gradient-to-br from-primary via-secondary to-primary/80" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-transparent" />

        <div className="relative flex flex-col justify-center p-5 md:p-6 lg:p-8 min-h-[280px] md:min-h-0">
          <div className="flex items-center gap-2 mb-3">
            {difficulty && (
              <span className="px-3 py-1 bg-accent text-accent-foreground text-xs md:text-sm font-medium rounded-full">
                {difficulty}
              </span>
            )}
            {isNew && (
              <span className="px-3 py-1 bg-success text-success-foreground text-xs md:text-sm font-medium rounded-full">
                Yeni Etkinlik
              </span>
            )}
          </div>

          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3 leading-tight break-words">
            {title}
          </h1>

          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-white/90">
            {date && (
              <div className="flex items-center gap-2 min-w-0">
                <Icon name="Calendar" size={16} className="flex-shrink-0" />
                <span className="text-sm md:text-base break-words">{date}</span>
              </div>
            )}
            {time && (
              <div className="flex items-center gap-2 min-w-0">
                <Icon name="Clock" size={16} className="flex-shrink-0" />
                <span className="text-sm md:text-base">{time}</span>
              </div>
            )}
            {location && (
              <div className="flex items-center gap-2 min-w-0">
                <Icon name="MapPin" size={16} className="flex-shrink-0" />
                <span className="text-sm md:text-base break-words">{location}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventHero;